import Hero from "../Services/Hero.jsx";
import VioletHaloBackground from "../hook/effects/HaloViolet.jsx";
import "../Services/Services.css";
import Avantage from "../Services/Avantage.jsx";
import About from "../Services/About.jsx";  
import Project from "../Services/Project.jsx";
import Service from "../Services/Service.jsx"
import AboveFooter from "../general/AboveFooter.jsx";
import Footer from "../general/Footer.jsx";
import Partenaires from "../Services/Partenaires.jsx";


export default function Services() {
  return (
    <>
      <Hero />
      <Avantage />
      <About />
      <Project />
      <Service/>
      <Partenaires />
      <VioletHaloBackground />
      <AboveFooter/>
      <Footer/>
    </>
  );
}
